import * as _ from "lodash";

export enum DataSourceCategory {
    CITY = 0,
    COUNTY = 1,
    STATE = 2
}

export function getPrettyDataSourceCategory(dataSourceCategory: number): string {
    return {
        "-1": 'N/A',
        0: 'City',
        1: 'County',
        2: 'State'
    }[String(_.defaultTo(dataSourceCategory, -1))];
}

export const dataSourceConverter = {
    'city': DataSourceCategory.CITY,
    'county': DataSourceCategory.COUNTY,
    'state': DataSourceCategory.STATE,
};

export function getDataSourceCategoriesArr(dataSourceCategories: object): Number[] {
    const dataSourceCategoriesArr = [];
    for (const layer in dataSourceCategories) {
        if (!dataSourceCategories[layer]) { continue; }
        const dataSourceCategory = dataSourceConverter[layer];
        if (_.isNumber(dataSourceCategory)) {
            dataSourceCategoriesArr.push(dataSourceCategory);
        }
    }
    return dataSourceCategoriesArr;
}
